import React from 'react';
import {Redirect} from 'react-router';

import ButtonLink from '../../elements/ButtonLink';
import SandboxedContent from '../../SandboxedContent/SandboxedContent';
import EnrichmentScreen from './common/EnrichmentScreen';

export default class EnrichmentsHomeIntroduction extends React.Component {
    render() {
        let {event, category, i18n, questions} = this.props;

        let nextQuestionId = _(questions)
            .reject(q => !q.question.editable && q.answer.length)
            .first().id;

        if (!category.intro_text && nextQuestionId) return <Redirect to={`${location.pathname}/question/${nextQuestionId}`} />;

        let footer = (
            <div className="content">
                <ButtonLink href={'./question/' + nextQuestionId} style={event._local.styles.button}>
                    {i18n['label.start']}
                </ButtonLink>
            </div>
        );

        console.log(category);

        return (
            <EnrichmentScreen event={event} enrichmentCategory={category} footer={footer}>
                <br />
                <SandboxedContent
                    content={category.intro_text}
                    fitHeightToContents
                    className="text main"
                    innerStyle={{
                        body: {'font-size': '120%'},
                    }}
                />
            </EnrichmentScreen>
        );
    }
}
